module.exports = __webpack_public_path__ + "5aed403ac039f1c377f197a969faffb4.png";